<template>
  <v-dialog v-model="dialog" width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="router-link-exact-active " text v-bind="attrs" v-on="on">
        Cookies policy
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <img :src="require('@/assets/cookies/ATRC Platform - Cookie Policy-1.png')" width="100%" />
        <img :src="require('@/assets/cookies/ATRC Platform - Cookie Policy-2.png')" width="100%" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CookiesPolicyModal',
  data: () => ({
    dialog: false,
  }),
};
</script>
